function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.4,56.7c-2.1,1.9-3,3.7-3,6.5c-1.2,32.2-14.4,58.2-42.6,74.7c-28.7,16.6-58.2,15.6-87.2-0.2c-0.5-0.3-1-0.7-2.1-1.5 c16.3,1.2,30.7-2.8,43.7-12.6c-6.6-0.9-12.5-2.5-17.4-6.3c-4.9-3.7-8.6-8.4-10.4-14.7c4.4,0,8.2,0,12.2,0c0-0.3,0.2-0.5,0.2-0.9 c-6.7-1.9-12.4-5.4-16.8-10.7c-4.2-5.4-6.3-11.6-6.5-18.5c4.2,1.2,8.4,2.3,12.4,3.5c0.2-0.3,0.3-0.5,0.5-0.9 C13.4,70.3,9,64.6,7.5,56.9C6,49.5,6.8,42.4,10.7,35.2c16.6,18.9,37.2,29.5,62.6,31.3c-0.9-6.2-0.9-12.1,1.4-17.8 c7.5-19.8,32.7-26.2,48.5-11.9c1.7,1.5,3.3,1.9,5.2,1.2c5.2-1.9,10.4-3.9,15.6-5.7c-2.1,6.5-6.3,11.2-11.6,15.9 c5.1-1.4,10.1-2.6,15.1-4c0.2,0.2,0.3,0.3,0.5,0.5C144.3,48.9,140.6,53.1,136.4,56.7z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      "enableBackground": "new 0 0 150 150"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/twitter.03892e3f.svg";
export { SvgComponent as ReactComponent };